import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import CancelReasonCustomTooltip from "./cancelReasonCustomTooltip";

// 각 파이 섹션에 대한 색상
const CancelReasonChart = ({ dataList }) => {
  const totalValue = dataList.reduce((acc, cur) => {
    acc += Number(cur.cancelcount);
    return acc;
  }, 0);

  const getCellColor = (title) => {
    switch (title) {
      case "CHANGE_MEMBERSHIP_OR_PAYMENT": // 결제 방식이나 멤버십 서비스를 변경하고 싶어요
        return "#cf6679";
      case "CONTENT_MISMATCH": // 기대했던 것과 콘텐츠의 내용이 달라요
        return "#1b5ddd";
      case "PRICE_BURDEN": // 가격이 부담돼요
        return "#ffa438";
      case "LOW_USAGE": // 이용을 잘 안해요
        return "#53bd20";
      case "LACK_OF_BENEFITS": // 구매자를 위한 혜택이 부족해요
        return "#46a196";
      case "ETC": // 기타
        return "#b658ff";
      default:
        return "#f3f3f3";
    }
  };

  return (
    <PieChart width={400} height={400}>
      <Pie
        data={dataList}
        dataKey="cancelcount"
        nameKey="cancelrequestreason"
        cx="50%"
        cy="50%"
        outerRadius={119}
        innerRadius={60} // 도넛 형태를 만들기 위해 설정
        label={({
          cx,
          cy,
          midAngle,
          innerRadius,
          outerRadius,
          cancelcount,
        }) => {
          const RADIAN = Math.PI / 180;
          const radius = innerRadius + (outerRadius - innerRadius) * 0.5; // 파이 내부에 위치시키기 위한 반경 계산
          const x = cx + radius * Math.cos(-midAngle * RADIAN); // x 좌표 계산
          const y = cy + radius * Math.sin(-midAngle * RADIAN); // y 좌표 계산

          return (
            <text
              x={x}
              y={y}
              fill="#f3f3f3" // 텍스트 색상
              textAnchor="middle"
              dominantBaseline="central" // 텍스트 수직 중앙 정렬
              style={{
                fontFamily: "Pretendard",
                fontWeight: 700,
                fontSize: 13,
                lineHeight: "20px",
                letterSpacing: "-0.3%",
              }}
            >
              <tspan
                textAnchor="middle"
                x={x}
                dy="0"
              >{`${cancelcount.toLocaleString()}명`}</tspan>
              <tspan textAnchor="middle" x={x} dy="15">{`(${(
                (cancelcount / totalValue) *
                100
              ).toFixed(1)}%)`}</tspan>
            </text>
          );
        }} // 금액과 비율 표시
        labelLine={false} // 라벨 라인 제거
        stroke="none" // 파이 섹션 테두리 제거
      >
        {dataList.map((item, index) => (
          <Cell
            key={`cell-${item}-${index}`}
            fill={getCellColor(item.cancelrequestreason)}
          />
        ))}
      </Pie>
      <Tooltip
        position={{ x: 350, y: 108 }}
        content={<CancelReasonCustomTooltip />}
      />
    </PieChart>
  );
};

export default CancelReasonChart;
